
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";

interface ContentTabHeaderProps {
  lastUpdated: string;
  previewMode: boolean;
  togglePreview: () => void;
  handleSave: () => void;
  saving: boolean;
}

const ContentTabHeader = ({
  lastUpdated,
  previewMode,
  togglePreview,
  handleSave,
  saving
}: ContentTabHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-2">
      <div className="text-sm text-muted-foreground">
        {lastUpdated}
      </div>
      <div className="flex space-x-2">
        <Button 
          variant="outline" 
          size="sm"
          onClick={togglePreview}
        >
          {previewMode ? "Edit" : "Preview"}
        </Button>
        <Button 
          size="sm" 
          onClick={() => {
            console.log("Save button clicked");
            handleSave();
          }}
          disabled={saving}
        >
          {saving ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="mr-2 h-4 w-4" />
              Save
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default ContentTabHeader;
